import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const PURCHASES = [{
  name: 'Mariana',
  city: 'Buenos Aires'
}, {
  name: 'Florencia',
  city: 'Córdoba'
}, {
  name: 'Carolina',
  city: 'Rosario'
}, {
  name: 'Luciana',
  city: 'Mendoza'
}, {
  name: 'Verónica',
  city: 'La Plata'
}, {
  name: 'Natalia',
  city: 'Mar del Plata'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Valentina',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    const triggerPopup = () => {
      // Pick random person
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (random between 15-30 seconds)
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(triggerPopup, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up max-w-xs w-full" data-id="element-224">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 p-4 flex items-start gap-3 relative" data-id="element-225">
        <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-226">
          <X size={14} data-id="element-227" />
        </button>

        <div className="bg-green-100 rounded-full p-2 flex-shrink-0" data-id="element-228">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-229" />
        </div>

        <div data-id="element-230">
          <p className="text-sm font-bold text-gray-900" data-id="element-231">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-232">
            acaba de comprar el{' '}
            <span className="font-semibold text-green-700" data-id="element-233">MegaPack</span>
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-234">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}